define('views/content/reports/applications',['require','backbone','marionette','bootstrap-daterangepicker','datatables','text!templates/content/reports/applications.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('bootstrap-daterangepicker');
    require('datatables');

    var temp = require("text!templates/content/reports/applications.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'applications',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                reportDateRangePicker: '#report-range-picker',
                reportDateRangeTabs: '.report-range-tabs',
                reportDateRangeTab: '.report-range-tabs li',

                resellerApplicationsTable: '.reseller-applications-list',
                customerApplicationsTable: '.customer-applications-list'
            };
        },

        events: {
            'click @ui.reportDateRangeTab': 'reportDateRangeTabClicked'
        },

        onRender: function () {
            var _this = this;

            this.ui.reportDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            this.ui.reportDateRangePicker.on('hide.daterangepicker', function () {
                _this.getReports();
            });

            var startTime = localStorage.getItem('report_start_time');
            var endTime = localStorage.getItem('report_end_time');
            if (startTime && endTime) {
                this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(new Date(parseInt(startTime)));
                this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(new Date(parseInt(endTime)));

                this.getReports();
            } else {
                this.ui.reportDateRangeTabs.find('li[data-range="day"]').click();
            }
        },

        reportDateRangeTabClicked: function (e) {
            var clickedTab = $(e.currentTarget);
            var currentTab = this.ui.reportDateRangeTabs.find('li.active');

            if (clickedTab != currentTab) {
                currentTab.removeClass('active');
                clickedTab.addClass('active');

                var rangeKey = clickedTab.attr('data-range');

                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                if (rangeKey == 'day') {
                    var today = new Date();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(today);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'week') {
                    var weekStart = App.utils.getWeekStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(weekStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'month') {
                    var monthStart = App.utils.getMonthStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);

                } else if (rangeKey == 'year') {
                    var yearStart = App.utils.getYearStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(yearStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'last_30_days') {
                    var monthAgo = new Date(tomorrow.getTime());
                    monthAgo.setDate(monthAgo.getDate() - 30);

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthAgo);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                }

                this.getReports();
            }
        },

        getReports: function () {
            var _this = this;

            // Save date parameters in local storage
            localStorage.setItem('report_start_time', this.ui.reportDateRangePicker.data('daterangepicker').startDate.toDate().getTime());
            localStorage.setItem('report_end_time', this.ui.reportDateRangePicker.data('daterangepicker').endDate.toDate().getTime());

            $.ajax({
                url: App.Config.apiBase + 'reports/application-reports/',
                method: 'get',
                data: {
                    start_date: this.ui.reportDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                    end_date: this.ui.reportDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD')
                },
                success: function (response) {
                    _this.showCustomerApplicationsReports(response.customer_application_report);
                    _this.showResellerApplicationsLeadReports(response.reseller_application_report);
                }
            });
        },

        showCustomerApplicationsReports: function (reportData) {
            // Transform report data for datatables format
            var gridData = [
                [
                    App.polyglot.t('local'),
                    reportData.local_customer_application_count
                ],
                [
                    App.polyglot.t('foreign'),
                    reportData.foreign_customer_application_count
                ],
                [
                    App.polyglot.t('total'),
                    reportData.local_customer_application_count + reportData.foreign_customer_application_count
                ]
            ];

            if (!this.customerApplicationsDataTable) {
                this.customerApplicationsDataTable = this.ui.customerApplicationsTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    columns: [
                        { title: App.polyglot.t('customer') },
                        { title: App.polyglot.t('count'), className: 'text-right' }
                    ]
                });
            } else {
                this.customerApplicationsDataTable.clear();
                this.customerApplicationsDataTable.rows.add(gridData);
                this.customerApplicationsDataTable.columns.adjust().draw();
            }
        },

        showResellerApplicationsLeadReports: function (reportData) {
            // Transform report data for datatables format
            var gridData = [
                [
                    App.polyglot.t('total'),
                    reportData.reseller_application_count
                ]
            ];

            if (!this.resellerApplicationsDataTable) {
                this.resellerApplicationsDataTable = this.ui.resellerApplicationsTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    columns: [
                        { title: App.polyglot.t('reseller') },
                        { title: App.polyglot.t('count'), className: 'text-right' }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.resellerApplicationsDataTable.clear();
                this.resellerApplicationsDataTable.rows.add(gridData);
                this.resellerApplicationsDataTable.columns.adjust().draw();
            }
        }

    });
});
